if (!customElements.get('gift-picker')) {
  customElements.define(
    'gift-picker',
    class GiftPicker extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onOptionClick.bind(this));
      }

      // Which reward tier this picker belongs to ('70' or '100'). Two gift pickers can be on
      // screen at once on a >100€ cart (feature 4, 16.09.2026) — this is what keeps them
      // independent: selecting a gift in one tier must never clear the other tier's selection,
      // so line items are tagged with `_gift_tier` instead of a single generic `_gift` flag.
      get tier() {
        return this.dataset.giftTier || '70';
      }

      onOptionClick(event) {
        const button = event.target.closest('[data-gift-picker-option]');
        if (!button || this.classList.contains('is-loading') || button.classList.contains('is-selected')) return;
        this.selectGift(button.dataset.variantId);
      }

      async selectGift(variantId) {
        this.classList.add('is-loading');
        const errorEl = this.querySelector('[data-gift-picker-error]');
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        const tier = this.tier;

        try {
          const cart = await fetch(`${window.routes.cart_url}.json`).then((r) => r.json());

          const otherGiftLinesSameTier = cart.items.filter(
            (item) =>
              item.properties &&
              item.properties._gift_tier === tier &&
              String(item.variant_id) !== String(variantId)
          );

          for (const line of otherGiftLinesSameTier) {
            await fetch(window.routes.cart_change_url, {
              ...fetchConfig(),
              body: JSON.stringify({ id: line.key, quantity: 0 }),
            });
          }

          const alreadyHasThisGift = cart.items.some(
            (item) =>
              item.properties &&
              item.properties._gift_tier === tier &&
              String(item.variant_id) === String(variantId)
          );

          if (!alreadyHasThisGift) {
            const response = await fetch(window.routes.cart_add_url, {
              ...fetchConfig(),
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1, properties: { _gift: 'yes', _gift_tier: tier } }],
              }),
            });

            if (!response.ok) {
              const err = await response.json().catch(() => ({}));
              throw new Error(err.description || err.message || 'gift-add-failed');
            }
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-picker' });
          } else {
            window.location.reload();
          }
        } catch (error) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = 'Възникна проблем с добавянето на подаръка — опитай отново.';
          }
          // eslint-disable-next-line no-console
          console.error('[gift-picker]', error);
        } finally {
          this.classList.remove('is-loading');
        }
      }
    }
  );
}
